import React from 'react'
import ReCAPTCHA from "react-google-recaptcha";

const Form = function form ({forget,formlogin,onChangeLogin,recaptchaRefLogin,onSubmitLogin}){
    return (    
        <main>
            <div className="back flex w90">
            <a href={https} className="flex">
                <img src={https+"img/back.svg"} alt="⬅"/>
                <span>Atrás</span>
            </a>
            </div>

            <img src={https+"img/banner2.jpg"} alt="user-banner" className="userBanner dnone"/>

            <section className="login">
                <div className="container colflex w90">
                    <img src={https+"img/userLog.svg"} alt="🙍‍♂️"/>
                    
                    <form id="formLogin" action="" onSubmit={onSubmitLogin}>
                        <ReCAPTCHA
                            ref={recaptchaRefLogin}
                            size="invisible"
                            sitekey="6LfcjZ0fAAAAAEqsOPo6f6Cmw9e2din9S2TxcM7m"
                        />
                        <input
                            type="hidden"
                            name="token"
                            value={formlogin.token}
                            onChange={onChangeLogin}
                        />
                        <input
                            name="user"
                            type="text"
                            value={formlogin.user}
                            onChange={onChangeLogin}
                            placeholder="Correo Electronico"
                        />
                        <input
                            name="password"
                            type="password"
                            value={formlogin.password}
                            onChange={onChangeLogin}
                            placeholder="Contraseña"
                        />
                        <a onClick={forget} className="forgetPass2" >¿Olvidaste tu contraseña?</a>
                        <br/><br/>
                        <button type="submit">
                            Iniciar sesión
                        </button>
                    </form>
                    <br/>
                    <span>Crear mi cuenta</span>
                    <a className="btnRegister2" href={https+'register'}> Registrarme</a>
                </div>
            </section>

        </main>
    )
}

export default Form